angular.module('main').directive('modalTerms', () => ({
	restrict: 'E',
	template() {
		let templateHtml = '';
		templateHtml += '<div id="terms" class="modal modal-center fade">';
		templateHtml += '    <div class="modal-dialog">';
		templateHtml += '        <div class="modal-content">';
		templateHtml += '            <div class="modal-header">';
		templateHtml +=
			'                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
		templateHtml +=
			'                <h3 class="modal-title">Terms and Conditions</h3>';
		templateHtml += '            </div>';
		templateHtml += '            <div class="modal-body">';
		templateHtml +=
			'                <p><span>By using Studio Ninja websites, their subdomains, or any website aliasing them ("Service"), and all services of Studio Ninja, you are agreeing to be bound by the following terms and conditions ("Terms of Service" or "Agreement").</span>';
		templateHtml += '                </p><br>';
		templateHtml +=
			'                <p><span>Studio Ninja reserves the right to update and change the Terms of Service from time to time without notice. Any new features that augment or enhance the current Service, including the release of new tools and resources, shall be subject to the Terms of Service. Continued use of the Service after any such changes shall constitute your consent to such changes.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <h3><span>Account Terms</span></h3>';
		templateHtml += '                <ul>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			'                           >You must be 13 years or older to use this Service.</span>';
		templateHtml += '                    </p></li>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			'                           >You must be a human. With the exception of published API interfaces, accounts may not be registered, updated, scanned, or otherwise accessed by "bots" or other automated methods.</span>';
		templateHtml += '                    </p></li>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			'                           >You must provide your legal full name, a valid email address, and any other information requested in order to complete the signup process.</span>';
		templateHtml += '                    </p></li>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			"                           >Your login may only be used by one person - a single login shared by multiple people is not permitted. You may create separate logins for as many people as you'd like (additional fees may apply).</span>";
		templateHtml += '                    </p></li>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			'                           >You are responsible for maintaining the security of your account and password. Studio Ninja cannot and will not be liable for any loss or damage from your failure to comply with this security obligation.</span>';
		templateHtml += '                    </p></li>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			'                           >You are responsible for all Content posted and activity that occurs under your account (even when Content is posted by others who have accounts under your account).</span>';
		templateHtml += '                    </p></li>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			'                           >You must not misrepresent yourself or take on the identity of someone else while using this service.</span>';
		templateHtml += '                    </p></li>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			'                           >One person or legal entity may not maintain more than one Free Forever Account.</span>';
		templateHtml += '                    </p></li>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			'                           >You may not use the Service for any illegal or unauthorized purpose.</span>';
		templateHtml += '                    </p></li>';
		templateHtml += '                    <li><p><span';
		templateHtml +=
			'                           >The Service may be available using a mobile device. Do not use the Service in a way that distracts you and prevents you from obeying traffic or safety laws.</span>';
		templateHtml += '                    </p></li>';
		templateHtml += '                </ul>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Violation of any of these agreements will result in the termination of your Account. While Studio Ninja prohibits such conduct and Content on the Service, you understand and agree that Studio Ninja cannot be responsible for the Content posted on the Service and you nonetheless may be exposed to such materials. You agree to use the Service at your own risk.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml += '                    <span>Code of Conduct</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>While using the Service, you agree to comply with all applicable laws, rules and regulations.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You also agree to comply with certain additional rules (the "Code of Conduct") that govern your use of the Service and participation at events or in online forums administered or organized by Studio Ninja ("Events", for example, instructional workshops, live webinars, and posts in the </span>';
		templateHtml += '                    <a';
		templateHtml +=
			'                        href="https://www.facebook.com/studioninjacrm">';
		templateHtml += '                        <span';
		templateHtml +=
			'                        style="color: #337ab7;background-color: transparent;">Studio Ninja User Group on Facebook</span>';
		templateHtml += '                    </a>';
		templateHtml += '                    <span';
		templateHtml +=
			'                       >). The Code of Conduct is not meant to be exhaustive, and Studio Ninja reserves the right to modify this Code of Conduct at any time, as well as take appropriate disciplinary measures including account termination and deletion to protect the integrity and spirit of the Service and Events, regardless of whether a specific behavior is listed here as prohibited.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>The following are examples of behavior that warrant disciplinary measures:</span>';
		templateHtml += '                </p>';
		templateHtml += '                <ul>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Harassing, stalking, or threatening any other users;</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Transmitting or communicating any content which, in the sole and exclusive discretion of Studio Ninja, is deemed offensive, including, but not limited to, language that is unlawful, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, sexually explicit, or racially, ethnically, or otherwise objectionable;</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Impersonating any person, business, or entity, including an employee of Studio Ninja, or communicating in any way that makes it appear that the communication originates from Studio Ninja;</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Posting private or identifying information about any other user or account, to the Service or elsewhere;</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Transmitting or facilitating the transmission of any content that contains a virus, corrupted data, worm, or other computer programming routines that are intended to and/or actually damage, detrimentally interfere with, surreptitiously intercept or mine, scrape or expropriate any system, data or personal information;</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Spamming, whether for personal or commercial purposes, by disrupting the flow of conversation with repeated postings of a similar nature;</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Participating in any action which, in the sole and exclusive judgment of Studio Ninja, "exploits" an undocumented aspect of the Service;</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Participating in any action which, in the sole and exclusive judgment of Studio Ninja, defrauds any other user of the Service, including, but not limited to, by "scamming" or "social engineering;"</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Using unauthorized programs or automated processes to interact with the Service;</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                    <li>';
		templateHtml += '                        <p>';
		templateHtml += '                            <span';
		templateHtml +=
			'                           >Accessing or attempting to access areas of the Service that have not been made available to the public;</span>';
		templateHtml += '                    </p>';
		templateHtml += '                    </li>';
		templateHtml += '                </ul>';
		templateHtml += '                <h3>';
		templateHtml +=
			'                    <span>Payment, Refunds, Upgrading and Downgrading Terms</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>A valid credit card is required for paying accounts. Free Forever accounts are not required to provide a credit card number.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>The Service is billed in advance on a monthly or yearly basis and is non-refundable. There will be no refunds or credits for partial months of service, upgrade/downgrade refunds, or refunds for months unused with an open account. In order to treat everyone equally, no exceptions will be made.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>All fees are inclusive of taxes, levies, or duties imposed by taxing authorities.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>For any upgrade or downgrade in plan level, your credit card that you provided will automatically be charged the new rate on your next billing cycle.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Any increased plan price upon upgrading will be prorated based on the time remaining in your current billing cycle and immediately charged upon upgrading.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Downgrading your Service may cause the loss of Content, features, or capacity of your Account. Studio Ninja does not accept any liability for such loss.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>All payments are final and are non-refundable.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml += '                    <span';
		templateHtml +=
			'                       >Cancellation and Termination</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>We may suspend or stop providing our Service to you if you do not comply with this Agreement or our policies or if we are investigating suspected misconduct. Studio Ninja, in its sole discretion, has the right to suspend or terminate your account and refuse any and all current or future use of the Service, or any other Studio Ninja service, for any reason at any time.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You are solely responsible for properly cancelling your account. An email, chat request, help desk ticket, or phone request to cancel your account is not considered cancellation. Sign into your account and cancel your subscription in Settings &gt; Account &amp; Subscription.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Upon submission of cancellation, your account will be suspended immediately without regard to the original term of your license and you will not be charged again.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>A Free Forever account is a limited account with no billing information on file. Free Forever accounts may have certain functional limitations, such as restricted number of users and restricted job management and invoicing capabilities. Upon expiration, a Free Forever account will not be accessible without provision of billing information and upgrading your plan level. A Free Forever Account will expire after you add more than one company user, or add more than 10 jobs, or exceed $3000 of invoices in your account.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Termination or cancellation of the Service will result in the deactivation or deletion of your account or your access to your account, and the forfeiture and relinquishment of all Content in your account. Studio Ninja reserves the right to refuse service to anyone for any reason at any time.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>If a payment fails, for example if there are insufficient funds or credit remaining, or if a card is lost or stolen, your account will be suspended until you renew your subscription plan and re-provide valid Credit Card payment details. If your account remains suspended for 90 days after the payment due date it will be considered abandoned and your account closed and scheduled for deletion.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>If you need additional time or if you need to update your credit card details, please contact us.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml +=
			'                    <span>Modifications to the Service and Prices</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Studio Ninja reserves the right at any time and from time to time to modify or discontinue, temporarily or permanently, any part of the Service with or without notice.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Prices of all Services, including but not limited to monthly subscription plan fees to the Service, are subject to change upon 30 days notice from us. Such notice may be provided at any time by posting the changes to the Studio Ninja Blog or the Service itself.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Studio Ninja shall not be liable to you or to any third party for any modification, price change, suspension or discontinuance of the Service.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml +=
			'                    <span>Copyright and Content Ownership</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>All content posted on the Service must comply with Australian copyright laws.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>We claim no intellectual property rights over the material you provide to the Service. Your account data and materials uploaded remain yours. However, if you or anyone else with an account under your account make any Content public, you agree to allow others to view and share your Content. You also understand and agree that Studio Ninja is not required to provide any specific export or archive of your data stored in the Service and that the various user-initiated export tools available in the Service (such as contact list or general ledger exports) are provided "as is" and "as available".</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Studio Ninja does not pre-screen Content, but Studio Ninja and its designee have the right (but not the obligation) in their sole discretion to refuse or remove any Content that is available via the Service.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>The look and feel of the Service is copyrighted by </span>';
		templateHtml += '                    <span';
		templateHtml += '                       >Studio Ninja Pty Ltd</span>';
		templateHtml += '                    <span';
		templateHtml +=
			'                       >. All rights reserved. You may not duplicate, copy, or reuse any portion of the HTML/CSS or visual design elements without express written permission from Studio Ninja.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>A Testimonial is an optional non-compensated review or recommendation that you may provide to Studio Ninja and includes the testimonial text, photo, business name, author, and website URL. By submitting a Testimonial you grant Studio Ninja the irrevocable, perpetual, transferable, and unrestricted right to reproduce, display, use, and publish your Testimonial for promotional purposes in any medium; and to alter the Testimonial photo without restriction. Studio Ninja is under no obligation to publish your Testimonial.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml += '                    <span>Privacy</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Our Privacy Policy explains how we treat your personal data and protect your privacy when you use our Service. By using our Service, you agree that Studio Ninja can use such data in accordance with our privacy policies.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml += '                    <span>General Conditions</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Technical support is only provided to paying account holders and is only available online or through email.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You understand that Studio Ninja uses third party vendors and hosting partners to provide the necessary hardware, software, networking, storage, and related technology required to run the Service.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You must not modify, adapt or hack the Service or modify another website so as to falsely imply that it is associated with the Service, Studio Ninja, or any other Studio Ninja service.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You may not reverse engineer or reuse source code that is in public view without express written permission from Studio Ninja. This includes any and all javascript. The code is copyrighted by Studio Ninja Pty Ltd.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You agree not to reproduce, duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, computer code that powers the Service, or access to the Service without the express written permission by Studio Ninja.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			"                    <span>We may, but have no obligation to, remove Content and Accounts containing Content that we determine in our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise objectionable or violates any party's intellectual property or these Terms of Service.</span>";
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Verbal, physical, written or other abuse (including threats of abuse or retribution) of any Studio Ninja customer, employee, member, or officer will result in immediate account termination.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You understand that the technical processing and transmission of the Service, including your Content, may be transferred unencrypted and involve (a) transmissions over various networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You must not upload, post, host, or transmit unsolicited email, SMSs, or "spam" messages.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You must not transmit any worms or viruses or any code of a destructive nature.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You may not use the provided storage for offsite backups, delivery or transfer of high-resolution images or proofs, or otherwise use excessive storage (as determined solely by Studio Ninja). If you are found to be abusing the provided storage, your account may be disabled until your storage usage is corrected.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>If your bandwidth usage exceeds 1 GB/month, or significantly exceeds the average bandwidth usage (as determined solely by Studio Ninja) of other Studio Ninja customers, we reserve the right to immediately disable your account or throttle your file hosting until you can reduce your bandwidth consumption.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>The failure of Studio Ninja to exercise or enforce any right or provision of the Terms of Service shall not constitute a waiver of such right or provision. The Terms of Service constitutes the entire agreement between you and Studio Ninja and govern your use of the Service, superseding any prior agreements between you and Studio Ninja (including, but not limited to, any prior versions of the Terms of Service).</span>';
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml += '                    <span';
		templateHtml +=
			'                       >Our Warranties and Disclaimers</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE".</span>';
		templateHtml += '                </p>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Studio Ninja does not warrant that (i) the service will meet your specific requirements, (ii) the service will be uninterrupted, timely, secure, or error-free, (iii) the results that may be obtained from the use of the service will be accurate or reliable, (iv) the quality of any products, services, information, or other material purchased or obtained by you through the service will meet your expectations, and (v) any errors in the Service will be corrected. To the extent permitted by law, we exclude all warranties.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			"                    <span>Other than as expressly set out in these Agreement, neither Studio Ninja nor its suppliers or distributors make any specific promises about the Service. For example, we don't make any commitments about the content within the Service, the specific functions of the Service, or their reliability, availability, or ability to meet your needs.</span>";
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml += '                    <span';
		templateHtml += '                       >Liability for our Service</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>Your use of the Service is at your sole risk.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>You expressly understand and agree that Studio Ninja shall not be liable for any direct, indirect, incidental, special, consequential or exemplary damages, including but not limited to, damages for loss of profits, goodwill, use, data or other intangible losses (even if Studio Ninja has been advised of the possibility of such damages), resulting from: (i) the use or the inability to use the service; (ii) the cost of procurement of substitute goods and services resulting from any goods, data, information or services purchased or obtained or messages received or transactions entered into through or from the Service; (iii) unauthorized access to or alteration of your transmissions or data; (iv) statements or conduct of any third party on the service; or (v) any other matter relating to the service.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml += '                    <span>Business Use</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			"                    <span>If you are using our Service on behalf of a business, that business accepts these terms. It will hold harmless and indemnify Studio Ninja and its affiliates, officers, agents, and employees from any claim, suit or action arising from or related to the use of the Service or violation of these terms, including any liability or expense arising from claims, losses, damages, suits, judgments, litigation costs and attorneys' fees.</span>";
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml += '                    <span>Resolving Complaints</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>INFORMAL RESOLUTION: We want to address your concerns without needing a formal legal case. Before filing a claim against Studio Ninja, you agree to make a good faith effort to resolve the dispute informally by sending a dispute notice to </span>';
		templateHtml += '                    <span';
		templateHtml +=
			'                        style="color: #337ab7;background-color: transparent;">support@studioninja.co</span>';
		templateHtml += '                    <span';
		templateHtml +=
			"                       >. Include a thorough description of your dispute in your notice, including a summary of the situation that caused the issue and your desired remedies. We'll try to resolve the dispute informally by contacting you via email. If a dispute is not resolved within 30 days of submission, you or Studio Ninja may bring a formal proceeding.</span>";
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			"                    <span>NO CLASS ACTIONS: You may only resolve disputes with us on an individual basis, and may not bring a claim as a plaintiff or a class member in a class, consolidated, or representative action. Class arbitrations, class actions, private attorney general actions, and consolidation with other arbitrations or actions aren't allowed.</span>";
		templateHtml += '                </p>';
		templateHtml += '                <h3>';
		templateHtml += '                    <span>General Provisions</span>';
		templateHtml += '                </h3>';
		templateHtml += '                <p>';
		templateHtml +=
			'                    <span>GOVERNING LAW: This Agreement shall be governed by the laws of Australia, without regard to principles of conflicts of law.</span>';
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml += '                <p>';
		templateHtml +=
			"                    <span>INTERPRETATION; SEVERABILITY; WAIVER; REMEDIES: Headings are for convenience only and shall not be used to construe the terms of this Agreement. If any term of this Agreement is found invalid or unenforceable by any court of competent jurisdiction, that term will be severed from this Agreement. No failure or delay by Studio Ninja in exercising any right hereunder will waive any further exercise of that right. Studio Ninja's rights and remedies hereunder are cumulative and not exclusive.</span>";
		templateHtml += '                </p>';
		templateHtml += '                <br>';

		templateHtml += '                <p>';
		templateHtml +=
			"                    <span>SUCCESSORS; ASSIGNMENT; NO THIRD PARTY BENEFICIARIES: This Agreement is binding upon and shall inure to the benefit of both parties and their respective successors, heirs, executors, administrators, personal representatives, and permitted assigns. You may not assign this Agreement without Studio Ninja's prior written consent. No third party shall have any rights hereunder.</span>";
		templateHtml += '                </p>';
		templateHtml += '                <br>';
		templateHtml +=
			'                <span>NOTICES: You consent to receive all communications including notices, agreements, disclosures, or other information from Studio Ninja electronically. Studio Ninja may provide all such communications by email or by posting them on the Service or Studio Ninja Blog. For support-related inquiries, you may send an email to </span>';
		templateHtml += '                <span>support@studioninja.co</span>';
		templateHtml +=
			"                <span>. Nothing herein shall limit Studio Ninja's right to object to subpoenas, claims, or other demands.</span>";
		templateHtml += '            </div>';
		templateHtml += '            <div class="modal-footer modal-foot">';
		templateHtml +=
			'                <button class="btn btn-default btn-lg" type="button" data-dismiss="modal" aria-hidden="true">Close</button>';
		templateHtml += '            </div>';
		templateHtml += '        </div>';
		templateHtml += '    </div>';
		templateHtml += '</div>';

		return templateHtml;
	},
	scope: {},
	replace: true,
	transclude: true
}));



// WEBPACK FOOTER //
// ./web/js/components/Modals/public/modalTerms.js